import React from 'react';
import PaymentCheckout from 'components/shared/PaymentCheckout';
import { useHPPayment } from 'hooks/useHPPayment';

/**
 * Drop-in HP payment checkout. Handles accessToken → fetchGuid → paymentHash internally.
 *
 * Props:
 *   domId       — unique per page instance, e.g. "payment-grn-1234"
 *   amount      — in paise, e.g. 50000 = ₹500
 *   orderType   — HP-internal key from PAYMENT_ORDER_TYPES, e.g. PAYMENT_ORDER_TYPES.DELIVERY
 *   fetchGuid   — async (sdkPayload, cachedTokenResp) => string
 *                 Your domain call that creates the payment entity and returns a PaymentGuid.
 *                 e.g. async () => { const r = await initiateGrnPayment(grnId); return r.guid; }
 *   onClose     — () => void
 *   onReady     — () => void  (optional)
 *   onMessage   — (type, payload) => void  (optional, for unhandled SDK events)
 *   orderPaymentEntityType — defaults to 1  (optional)
 *   redirectUrl — defaults to origin + /buyer/payment/result  (optional)
 *   className   — wrapper div class  (optional)
 *
 * Usage:
 *   <HPPaymentCheckout
 *     domId="payment-grn-1234"
 *     amount={50000}
 *     orderType={PAYMENT_ORDER_TYPES.DELIVERY}
 *     fetchGuid={async (sdkPayload) => {
 *       const result = await initiateGrnPayment({ grnId, method: sdkPayload.payment_method_type });
 *       return result.guid;
 *     }}
 *     onClose={() => setShowPayment(false)}
 *   />
 */
export default function HPPaymentCheckout({ domId, amount, orderType, fetchGuid, onClose, onReady, onMessage, orderPaymentEntityType, redirectUrl, className }) {
  const paymentProps = useHPPayment({
    amount,
    orderType,
    fetchGuid,
    orderPaymentEntityType,
    redirectUrl,
    onClose,
    onReady,
    onMessage,
  });

  return (
    <PaymentCheckout
      domId={domId}
      className={className}
      {...paymentProps}
    />
  );
}
